import React, { useEffect, useState } from 'react';
import './setting.css';
import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
//import { useNavigate, useLocation } from "react-router-dom";
import App from "./App.js"; 
	
console.log('[[ setting page ]]');

const handleLogout = () => {
    // localStorage에서 토큰 제거
    localStorage.removeItem('token');
    // 로그아웃 상태 처리
    App.setToken('');
};

const SettingMenu = () => {

		console.log('[[ setting page : SettingMenu ]]');

    const handleLogoutClick = () => {
        handleLogout(); // 로그아웃 함수 호출
    };

    return (
		<div className="Loggoutbutton" onClick={handleLogoutClick}>로그아웃</div>
    );
};

export default SettingMenu;